(function helper(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Helpers = global.NewHomeSource.Helpers || {};

  class Array {
    /**
     * Returns an array of the keys of the given array, converted to numbers.
     *
     * @param {Array|Object} array - The array or object whose keys are to be returned.
     * @returns {number[]} An array of numeric keys.
     */
    static arrayKeys(array) {
      return Object.keys(array).map(Number);
    }

    /**
     * Returns the last valid index of the given array.
     * If the array is empty, returns 0.
     *
     * @param {Array} array - The array to get the last index from.
     * @returns {number} The last valid index of the array, or 0 if the array is empty.
     */
    static arrayLastIndex(array) {
      return Math.max(0, array.length - 1);
    }

    /**
     * Returns the last element of the given array.
     *
     * @param {Array} array - The array from which to retrieve the last element.
     * @returns {*} The last element of the array.
     */
    static arrayLast(array) {
      return array[Array.arrayLastIndex(array)];
    }
  }

  global.NewHomeSource.Helpers.Array = Array;
}(window));
